import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box, Button, Divider, IconButton, Stack, TextField } from "@mui/material";
import { Fragment } from "react";
import type { EmailContactRow } from "./emailContactRowsValidation";
import { emptyEmailRow, validateEmailContactRows } from "./emailContactRowsValidation";
import type { RoleExternal } from "./organizationContactsState";

interface Props {
  rows: EmailContactRow[];
  onChange: (rows: EmailContactRow[]) => void;
  showErrors: boolean;
}

const EmailContactsEditor = ({ rows, onChange, showErrors }: Props) => {
  const { rowErrors } = validateEmailContactRows(rows);

  const updateRow = (index: number, patch: Partial<RoleExternal>) =>
    onChange(rows.map((row, i) => (i === index ? { ...row, ...patch } : row)));

  const addRow = () => onChange([...rows, emptyEmailRow()]);

  const removeRow = (index: number) => onChange(rows.filter((_, i) => i !== index));

  return (
    <Stack spacing={2}>
      {rows.map((row, index) => {
        const rowError = rowErrors[index] ?? {};
        return (
          <Fragment key={row.id}>
            {index > 0 && <Divider sx={{ borderStyle: "dashed" }} />}
            <Stack direction="row" spacing={1} sx={{ alignItems: "flex-start" }}>
              <Stack spacing={1.5} sx={{ flex: 1, minWidth: 0 }}>
                <TextField
                  fullWidth
                  label="Name"
                  value={row.name}
                  error={showErrors && Boolean(rowError.name)}
                  helperText={showErrors ? rowError.name : undefined}
                  onChange={(event) => updateRow(index, { name: event.target.value })}
                />
                <TextField
                  fullWidth
                  label="Email"
                  value={row.email}
                  error={showErrors && Boolean(rowError.email)}
                  helperText={showErrors ? rowError.email : undefined}
                  onChange={(event) => updateRow(index, { email: event.target.value })}
                />
              </Stack>
              {index > 0 && (
                <IconButton color="error" sx={{ mt: 0.5 }} onClick={() => removeRow(index)}>
                  <CloseRoundedIcon />
                </IconButton>
              )}
            </Stack>
          </Fragment>
        );
      })}
      <Box>
        <Button variant="outlined" color="secondary" size="small" startIcon={<AddRoundedIcon />} onClick={addRow}>
          Add another Email
        </Button>
      </Box>
    </Stack>
  );
};

export default EmailContactsEditor;
